export function EmptyState() {
  // T-230: the prompt sits directly over map tiles, where plain text washed out over light land
  // or busy urban areas. A semi-transparent themed scrim (bg-card at partial opacity + a light
  // backdrop blur + shadow) — the same surface idiom as the legend / coverage banner / score card
  // — keeps the copy legible over any underlying imagery, in both light and dark themes. Presentation
  // only: copy, positioning, and behaviour are unchanged.
  return (
    <div className="flex flex-col items-center justify-center gap-2 rounded-xl bg-card/85 px-4 py-6 text-center shadow-lg backdrop-blur-sm">
      <p className="text-sm font-bold text-foreground">Select a location to begin</p>
      <p className="text-xs text-muted-foreground">
        Search an address or drop a pin anywhere on the map.
      </p>
    </div>
  )
}
